import React from 'react'
import { IRequisiteAuditItem } from '../core/response.types'
import { CATEGORY_LABEL } from '../core/consts'

const CATEGORY_BADGE_CLASS: Record<string, string> = {
  lifecycle:      'badge-light-danger',
  balance_change: 'badge-light-warning',
  enabled_toggle: 'badge-light-warning',
  limits_change:  'badge-light-info',
  card_change:    'badge-light-primary',
  meta_change:    'badge-light',
  other:          'badge-light-secondary',
}

interface Props { item: IRequisiteAuditItem }

const RequisiteAuditChangesCell: React.FC<Props> = ({ item }) => {
  const badgeClass = CATEGORY_BADGE_CLASS[item.category] ?? 'badge-light'

  if (item.type === 'insert') {
    return (
      <div>
        <span className={`badge ${badgeClass} me-2`}>{CATEGORY_LABEL[item.category]}</span>
        <span>Создан реквизит</span>
      </div>
    )
  }
  if (item.type === 'remove') {
    return (
      <div>
        <span className={`badge ${badgeClass} me-2`}>{CATEGORY_LABEL[item.category]}</span>
        <span>Удалён реквизит</span>
      </div>
    )
  }

  return (
    <div>
      <div className='mb-1'>
        <span className={`badge ${badgeClass}`}>{CATEGORY_LABEL[item.category]}</span>
      </div>
      <div>
        {item.changes.map(c => (
          <div key={c.field} className='small'>
            <strong>{c.label}:</strong> {c.oldValue ?? '—'} <span className='text-muted'>→</span> {c.newValue ?? '—'}
          </div>
        ))}
      </div>
    </div>
  )
}

export default RequisiteAuditChangesCell
